import { render, staticRenderFns } from "./HSpeciality.vue?vue&type=template&id=64752614&scoped=true&"
import script from "./HSpeciality.vue?vue&type=script&lang=js&"
export * from "./HSpeciality.vue?vue&type=script&lang=js&"
import style0 from "./HSpeciality.vue?vue&type=style&index=0&id=64752614&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64752614",
  null
  
)

export default component.exports